<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Advertisers</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_ADVERTISER_WRITE']"  class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Advertiser
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th>Logo</th>
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="companyName">Company Name</th>
            <th tableSorterHeader="lastname">Contact Name</th>
            <th tableSorterHeader="country">Country</th>
            <th tableSorterHeader="phoneNumber">Phone Number</th>
            <th tableSorterHeader="email">Email</th>
            <th tableSorterHeader="status">Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (advertiser of advertisers; track advertiser) {
            <tr>
              <td>
                <div class="logo">
                  @if (advertiser.logo) {
                    <img [ngSrc]="imageService.getImageUrl(advertiser.logo, 128, 128)" alt="Logo" fill/>
                  }
                </div>
              </td>
              <td>{{ advertiser.id }}</td>
              <td>{{ advertiser.companyName }}</td>
              <td>{{ advertiser.getContactName() }}</td>
              <td>
                <img [ngSrc]="countryService.getFlag(advertiser.country ?? '')" [alt]="advertiser.country" width="24" height="24">
                {{ countryService.getName(advertiser.country ?? '') }}
              </td>
              <td>{{ advertiser.phoneNumber }}</td>
              <td>{{ advertiser.email }}</td>
              <td>
                <span class="badge" [ngClass]="advertiser.getStatusClass()">{{ advertiser.getStatusName() }}</span>
              </td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[advertiser.id]"><i
                class="bi bi-pencil me-1"></i>Edit
              </a>
              <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(advertiser)" *isGranted="['ROLE_API_ADVERTISER_WRITE']"><i
              class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
</div>
